import {
  type CriteriaFilterValue,
  V2Disclosure,
  V2DisclosureHeader,
  V2DisclosurePanel,
} from "@stacklet/ui";

import { FilterChip } from "./FilterChip";

interface Props {
  providerFilters?: CriteriaFilterValue[];
  accountFilters?: CriteriaFilterValue[];
  resourceFilters?: CriteriaFilterValue[];
  policyFilters?: CriteriaFilterValue[];
  bindingFilters?: CriteriaFilterValue[];
  readOnly?: boolean;
}

export function SelectedRulesFiltersDisclosure({
  providerFilters = [],
  accountFilters = [],
  resourceFilters = [],
  policyFilters = [],
  bindingFilters = [],
  readOnly = false,
}: Props) {
  function renderFilterChipRow(title: string, filters: CriteriaFilterValue[]) {
    return (
      <div className="flex items-center gap-x-2">
        <div className="w-[4rem] text-label-small">{title}</div>
        <div className="flex flex-wrap gap-x-1">
          {filters?.map((filterValue, index) => (
            <FilterChip
              filterValue={filterValue}
              key={`${filterValue.criteria}-filter-${index}`}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <V2Disclosure
      className="rounded-1 border border-overlay-medium bg-background-secondary"
      isDisabled={readOnly}
      defaultExpanded
    >
      <V2DisclosureHeader className="p-md">Filters</V2DisclosureHeader>
      <V2DisclosurePanel>
        <div className="flex flex-col gap-y-4 p-md">
          {renderFilterChipRow("Provider", providerFilters)}
          {renderFilterChipRow("Account", accountFilters)}
          {renderFilterChipRow("Resource", resourceFilters)}
          {renderFilterChipRow("Policy", policyFilters)}
          {renderFilterChipRow("Binding", bindingFilters)}
        </div>
      </V2DisclosurePanel>
    </V2Disclosure>
  );
}
